import { connect } from 'react-redux';
import LoginOnlyBySso from './LoginOnlyBySso';

const mapStateToProps = state => ({

});

const mapDispatchToProps = dispatch => ({

});


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginOnlyBySso);



// WEBPACK FOOTER //
// ./src/components/LoginOnlyBySso/index.js